import { WSService } from "../../utils/WSService";

export const serviceBackgroundChecks = new WSService("/background-checks");
